import Header from "../components/Header";
import CreateForm from "./components/CreateForm";

export default function CreateVouchers() {
    let pagesLinks = [
        {
            name: "أنشاء أكود",
            link: `/admin/vouchers`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
    ];

    return (
        <div>
            <Header
                pageName="أنشاء أكود"
                pages={pagesLinks}
                className="text-2xl"
            />
            <CreateForm />
        </div>
    );
}